import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'ld-message-center-skeleton',
  template: `
    <div id="message-center-skeleton" class="bg-white rounded-card shadow-card animate-pulse">
      <div class="flex border-b border-ld-border">
        <div class="flex items-center gap-2 px-4 sm:px-6 py-3 sm:py-4 border-b-2 border-gray-300">
          <div class="h-4 w-16 bg-gray-300 rounded"></div>
          <div class="h-5 w-6 bg-gray-300 rounded-full"></div>
        </div>
        <div class="px-4 sm:px-6 py-3 sm:py-4 border-b-2 border-transparent">
          <div class="h-4 w-24 bg-gray-200 rounded"></div>
        </div>
      </div>

      <div class="divide-y divide-ld-border">
        @for (row of skeletonRows; track row) {
          <div class="flex items-center gap-2 sm:gap-4 px-3 sm:px-6 py-3 sm:py-4">
            <div class="w-2 shrink-0">
              <div class="w-2 h-2 bg-gray-200 rounded-full"></div>
            </div>

            <div class="w-32 shrink-0 max-sm:hidden">
              <div class="h-4 w-20 bg-gray-200 rounded"></div>
            </div>

            <div class="flex-1 min-w-0">
              <div class="h-4 w-3/4 bg-gray-200 rounded mb-1.5"></div>
              <div class="h-3 w-1/2 bg-gray-200 rounded"></div>
            </div>

            <div class="w-16 sm:w-24 shrink-0">
              <div class="h-3 w-14 bg-gray-200 rounded ml-auto"></div>
            </div>

            <div class="shrink-0 max-sm:hidden">
              <div class="h-5 w-5 bg-gray-200 rounded"></div>
            </div>
          </div>
        }
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageCenterSkeletonComponent {
  protected readonly skeletonRows = [1, 2, 3, 4, 5, 6];
}
